import { Check } from "@phosphor-icons/react";

export default function FlakeGrid({ flakes, selectedId, onSelect }) {
  return (
    <div className="grid grid-cols-3 gap-3" data-testid="flake-grid">
      {flakes.map((f) => {
        const active = f.id === selectedId;
        return (
          <button
            key={f.id}
            type="button"
            onClick={() => onSelect(f.id)}
            className={`group relative aspect-square rounded-xl overflow-hidden border-2 transition-all duration-200 ${
              active
                ? "border-[color:var(--epx-primary)] ring-2 ring-[color:var(--epx-primary)]/30 ring-offset-2 ring-offset-[color:var(--epx-surface)]"
                : "border-white/10 hover:border-white/30 hover:scale-[1.02]"
            }`}
            style={{
              backgroundImage: `url("${f.image}")`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
            data-testid={`flake-${f.id}`}
            aria-pressed={active}
          >
            <div
              className="absolute inset-0"
              style={{
                background:
                  "linear-gradient(180deg, rgba(0,0,0,0) 40%, rgba(0,0,0,0.75) 100%)",
              }}
            />
            <div className="absolute bottom-1.5 left-2 right-2 text-left">
              <p className="text-[11px] font-semibold text-white drop-shadow-sm font-heading">
                {f.name}
              </p>
            </div>
            {active && (
              <div
                className="absolute top-1.5 right-1.5 w-5 h-5 rounded-full flex items-center justify-center"
                style={{ background: "var(--epx-primary)" }}
              >
                <Check size={12} weight="bold" color="#0a0a0a" />
              </div>
            )}
          </button>
        );
      })}
    </div>
  );
}
